$(function () {
    if (typeof $.validator !== 'undefined') {
        $.validator.setDefaults({
            ignore: puritanLawn.validatorIgnoreQuillAndRecaptcha
        });
    }

    var $wysiwyg = document.getElementById('wysiwyg');
    var editor = puritanLawnJodit.create('#wysiwyg', '#wysiwyg', {
        initialHtml: ($wysiwyg && $wysiwyg.value) ? $wysiwyg.value : '',
        formSelector: '#pl-form',
        buttons: [
            'paragraph', '|',
            'bold', 'italic', 'underline', '|',
            'ul', 'ol', '|',
            'left', 'center', 'right', '|',
            'kygImageUpload', '|',
            'undo', 'redo'
        ],
        imageHandler: function () {
            $('#imageFileTMCE').trigger('click');
        }
    });

    $('#imageFileTMCE').on('change', function () {
        var files = this.files;
        if (!files || !files.length) {
            return;
        }
        var formData = new FormData();
        formData.append('Files', files[0]);
        formData.append('fileType', puritanLawn.fileType.DynamicContentImage);

        puritanLawn.ajaxPostMultiPartFormData(puritanLawn.adminServicesBaseAddress + 'UploadFiles',
            formData,
            function (results) {
                puritanLawnJodit.insertImageUrl(editor, results[0].url);
                $('#imageFileTMCE').val('');
            },
            function () {
                alert('error');
            }
        );
    });

    $('#pl-form-submitButton').on('click', function () {
        puritanLawnJodit.sync(editor, document.getElementById('wysiwyg'));
    });
});

function initViewModel(model) {
    var viewModel = {
        deceasedId: model.deceasedId,
        deceasedImagePathRoot: model.deceasedImagePathRoot,
        grc: null,
        onCancel: function () {
            puritanLawn.showTwoButtonModal('Cancel Submission',
                'Are you sure you want to cancel your changes?',
                'Yes',
                function () {
                    window.location.href = '/Deceased/Index/' + model.deceasedId;
                },
                'No');
        },
        onSubmit: function () {
            if (puritanLawn.viewModel.grc === null || puritanLawn.viewModel.grc === false) {
                puritanLawn.showOneButtonModal('Security Check',
                    'Please confirm you are not a robot before submitting.',
                    'OK');
                return;
            }

            puritanLawn.showTwoButtonModal('Confirm Submission',
                'Are you sure you want to sign the memorial book?',
                'Yes',
                function () {
                    $('#pl-form-cancelButton').prop('disabled', true);
                    $('#pl-form-submitButton').prop('disabled', true);
                    $('#pl-form-submitButton span:first-of-type').show();
                    $('#pl-form').submit();
                },
                'No');
        }
    };

    return viewModel;
}
